<template>
 <div class="text-sm text-gray-500">
   {{ summary?.map(item => `${item.name}: ${item.value}`).join(' · ') }}
</div>
</template>

<script setup lang="ts">
import type { PropertySummary } from '~/types';

defineProps<{
  summary: PropertySummary[]
}>()
</script>